import { distinctValues } from './distinctValues';
import { isNullOrUndefined } from './is-null-or-undefined';

export function sequenceEqual<T>(a: Iterable<T>, b: Iterable<T>, options?: { equal?: (x: T, y: T) => boolean, distinctOnly?: boolean }) {
  let equal = options?.equal;
  let distinctOnly = options?.distinctOnly;

  equal ??= (x, y) => {
    if (isNullOrUndefined(x) || isNullOrUndefined(y))
      return isNullOrUndefined(x) && isNullOrUndefined(y);

    return x === y;
  };

  if (distinctOnly) {
    a = distinctValues(a);
    b = distinctValues(b);
  }

  let itemsA = Array.isArray(a) ? a : [...a];

  if (Array.isArray(b)) {
    if (itemsA.length !== b.length)
      return false;

    for (let i = 0; i < itemsA.length; ++i) {
      if (!equal(itemsA[i], b[i]))
        return false;
    }
  }
  else {
    let index = 0;

    for (let y of b) {
      if (!equal(itemsA[index], y))
        return false;

      index++;

      if (index == itemsA.length)
        break;
    }

    if (index != itemsA.length)
      return false;
  }

  return true;
}
